var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column mobile-commune-partner-display"},_vm._l((_vm.communePartners),function(partner){return _c('commune-partner-card',{key:partner.id,staticClass:"mt-4",attrs:{"user-commune-partner":partner}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }